
declare const ChartDataLabels: any;
declare const Chart: any;

if (typeof Chart !== 'undefined') {
    Chart.defaults.set('plugins.datalabels', {
        color: '#FFFFFF',
        textStrokeColor: '#000000',
        textStrokeWidth: '5'
    });
}

interface IChartRequestFilter {
    $type?: string;
    input?: string;
}
interface IChartRequest {
    chart: string;
    filter: IChartRequestFilter;
}
interface IChartResponse {
    data: any;
}
interface IChartInfo {
    name: any;
    type: string;
    options: any;
    filter: IChartRequestFilter;
    chart: string;
    refreshTime: number;
}


class SiteElementChart
    extends QueryElement<HTMLCanvasElement> {

    private _chart: any | undefined;
    private readonly _info: IChartInfo;
    private _refreshTimer: number | null = null;
    private readonly _context: CanvasRenderingContext2D;

    constructor(card: ISiteCard, element: HTMLCanvasElement) {
        super(element, true);

        var context = element.getContext('2d');
        if (context == null)
            throw "Cannot get context";
        
        this._context = context;
        
        let path = this.getAttr('data-path');
        this._info = card.Model.get((path && SiteModel.split(path)) || []) as IChartInfo;
        if (this._info === undefined)
            throw "Cannot fetch info";
        
        // Add title to chart
    
        let title = this._info.options.plugins.title;
        if (title)
            title.text = this._info.name[card.Container.SiteConfig.language];
        
        // Create chart
        // BUG FIREFOX: wait 1ms before initializing
        setTimeout(() => this.initialize(), 1);
    }

    initialize() {
        this._chart = new Chart(this._context, {
            type: this._info.type,
            options: this._info.options,
            plugins: [ChartDataLabels]
        });
        this.refresh();
    }

    async refresh() {

        if (this._info.refreshTime > 0) {
            this._refreshTimer = setTimeout(async () => {
                await this.refresh();
            }, this._info.refreshTime * 1000);
        }

        let chartRequest: IChartRequest = {
            filter: this._info.filter,
            chart: this._info.chart
        };

        let request = new QueryRequest('Api/Chart', {
            contentType: 'json',
            method: 'post',
            data: JSON.stringify(chartRequest)
        });

        let response = await request.request();
        let chartResponse = await response.json() as IChartResponse;

        if (this._chart == null)
            throw "Chart not initialized."
        
        // Update labels
        if (this._chart.data.labels && chartResponse.data.labels) {
            for (let x in chartResponse.data.labels) {
                let source = chartResponse.data.labels[x];
                let target = this._chart.data.labels[x];
                if (target != source)
                    this._chart.data.labels[x] = source;
            }
        } else {
            this._chart.data.labels = chartResponse.data.labels;
        }

        // Update datasets
        if (this._chart.data.datasets && chartResponse.data.datasets) {
            for (let x in chartResponse.data.datasets) {
                let source = chartResponse.data.datasets[x] as any;
                let target = this._chart.data.datasets[x] as any;
                
                if (!target) {
                    this._chart.data.datasets.push(source);
                } else {
                    for (let y in source) {
                        target[y] = source[y];
                    }
                }
            }
            // Delete missing datasets
            this._chart.data.datasets.splice(
                chartResponse.data.datasets.length - 1,
                this._chart.data.datasets.length - chartResponse.data.datasets.length);
        } else {
            this._chart.data.datasets = chartResponse.data.datasets;
        }

        this._chart.update();
    }

    
    async remove(removeInner = true) {
        await super.remove(removeInner);

        if (this._refreshTimer)
            clearTimeout(this._refreshTimer);
    }
}